import { Search, Bell } from "lucide-react";
import Avatar from "./Avatar";
import { MOD_TITLES, ROLES } from "../constants";

export default function TopBar({ mod, search, setSearch, notifs, notifOpen, setNotifOpen, userName, role }) {
  const roleInfo = ROLES[role] || ROLES.comercial;
  const roleColor = { admin: "#C02646", gerente: "#005BED", comercial: "#46C026" }[role] || "#94a3b8";
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "12px 20px", background: "#fff",
      borderBottom: "1px solid rgba(128,128,128,0.08)", flexShrink: 0,
      flexWrap: "wrap", gap: 8,
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    }}>
      <h1 style={{ fontSize: 18, fontWeight: 700, color: "#333333", margin: 0 }}>
        {MOD_TITLES[mod]}
      </h1>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ position: "relative" }}>
          <Search size={13} style={{ position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar..."
            style={{
              padding: "6px 8px 6px 28px", borderRadius: 8,
              border: "1px solid rgba(128,128,128,0.08)", fontSize: 13,
              width: 200, outline: "none", background: "rgba(128,128,128,0.08)",
              color: "#555",
            }}
          />
        </div>
        <div style={{ position: "relative" }}>
          <button
            onClick={() => setNotifOpen(!notifOpen)}
            style={{
              width: 32, height: 32, borderRadius: 8,
              border: "1px solid rgba(128,128,128,0.08)", background: "rgba(128,128,128,0.08)",
              cursor: "pointer", display: "flex",
              alignItems: "center", justifyContent: "center",
              position: "relative",
            }}
          >
            <Bell size={13} color="#64748b" />
            {notifs.length > 0 && (
              <div style={{
                position: "absolute", top: -3, right: -3,
                width: 13, height: 13, borderRadius: "50%",
                background: "#ef4444", color: "#fff",
                fontSize: 8, fontWeight: 700,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                {notifs.length}
              </div>
            )}
          </button>
          {notifOpen && (
            <div style={{
              position: "absolute", right: 0, top: 36, width: 300,
              background: "#fff", borderRadius: 10,
              boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
              border: "1px solid #e5e7eb", zIndex: 100,
              maxHeight: 300, overflow: "auto",
            }}>
              <div style={{ padding: "10px 14px", borderBottom: "1px solid #f1f5f9", fontWeight: 700, fontSize: 12 }}>
                Alertas ({notifs.length})
              </div>
              {notifs.length === 0 && (
                <div style={{ padding: "14px", fontSize: 11, color: "#94a3b8", textAlign: "center" }}>
                  Nenhum alerta 
                </div>
              )}
              {notifs.map((n, i) => (
                <div key={i} style={{ padding: "8px 14px", borderBottom: "1px solid #f8fafc", fontSize: 11, color: "#475569" }}>
                  {n.text}
                </div>
              ))}
            </div>
          )}
        </div>
        <Avatar name={userName || "Usuário"} size={28} />
        {userName && <span style={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>{userName}</span>}
        <span style={{
          fontSize: 9, fontWeight: 700, color: roleColor,
          background: `${roleColor}15`, padding: "2px 8px",
          borderRadius: 10, textTransform: "uppercase", letterSpacing: "0.05em",
        }}>{roleInfo.label}</span>
      </div>
    </div>
  );
}
